import moment from "moment";
import { useContext } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import packageJson from "../../../../package.json";
import AppContext from "../../../AppContext";
import FooterLogo from "../../../assets/images/footer-logologin.png";
import SwitchButton from "../buttons/SwitchButton";

// #region  SCOPED CSS
const StyledPage = styled.div`
    @media only screen and (max-width: 1200px) {
        .compact-menu {
            display: none !important;
        }
    }

    @media only screen and (max-width: 1756px) {
        &.isSidePanelOpen .main-header .left-btns {
            display: none;
        }

        &.isSidePanelOpen .main-header .center-btns {
            margin-left: 18px;
        }

        &.isSidePanelOpen .left-footer-menu {
            display: none;
        }
    }

    .footer-container {
        width: 100%;
        height: 40px;
        background: #0e0f10;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
        z-index: 1032;
        min-width: 1024px;
    }

    /* FOOTER LOGO */
    .footer-logo {
        background: #0e0f10;
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        box-sizing: border-box;
        display: flex;
        flex-shrink: 0;
        width: 220px;
        height: 40px;
        align-items: center;
        justify-content: center;
        border-right: 1px solid rgba(255, 255, 255, 0.1);
    }

    .footer-logo img {
        margin: 8px 16px;
        width: 98px;
    }

    /* FOOTER LEFT */
    .left-footer-menu {
        height: 40px;
        padding-left: 15px;
    }

    .control-component {
        padding-right: 35px;
    }

    .control-description {
        color: #a6adb1;
        font-size: 10px;
        margin-right: 10px;
        margin-top: 2px;
    }

    .left-footer-menu .switch {
        display: flex;
        align-self: center;
        height: 16px;
        margin: 0;
        position: relative;
        width: 45px;
    }

    .left-footer-menu .switch input {
        height: 0;
        opacity: 0;
        width: 0;
    }

    .left-footer-menu .slider.round {
        border-radius: 34px;
        outline: none;
    }

    .left-footer-menu .slider {
        background-color: var(--backgrounds-lines-n-600);
        bottom: 0;
        cursor: not-allowed;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        transition: 0.4s;
    }

    .left-footer-menu .slider.round:before {
        border-radius: 50%;
    }

    .left-footer-menu .slider:before {
        background-color: var(--text-icons-gray-300);
        border: 0;
        bottom: 2px;
        content: "";
        height: 12px;
        left: 2px;
        position: absolute;
        transition: 0.4s;
        width: 12px;
        filter: none;
    }

    .left-footer-menu input:checked + .slider {
        background-color: var(--backgrounds-lines-n-600);
    }

    .left-footer-menu .slider.round {
        border-radius: 34px;
        outline: none;
    }

    .left-footer-menu input:checked + .slider:before {
        background-color: var(--text-icons-gray-300);
        -webkit-transform: translateX(29px);
        transform: translateX(29px);
    }
    .left-footer-menu .slider.round:before {
        border-radius: 50%;
    }

    /* Child switch geometry is scoped here; all native inputs stay disabled. */
    .left-footer-menu .switch-button .switch {
        height: 16px;
    }
    .left-footer-menu .switch-button .slider {
        background: #0e0f10;
        box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);
    }
    .left-footer-menu .switch-button .slider:before {
        border: 0;
        width: 12px;
        height: 12px;
        left: 2px;
        bottom: 2px;
        filter: none;
    }
    .left-footer-menu .switch-button input:checked + .slider.round:before {
        -webkit-transform: translateX(29px);
        transform: translateX(29px);
    }
    .footer-links a:focus-visible {
        outline: 2px solid #efbf73 !important;
        outline-offset: 3px !important;
        border-radius: 3px;
    }
    .footer-links a:hover span { color: #efbf73; }

    /* FOOTER RIGHT */
    .footer-links {
        display: flex;
    }

    .footer-links span {
        display: flex;
        list-style: none;
        font-size: 10px;
        margin-left: 20px;
    }
`;
// #endregion

/** Footer component.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} [props.className] - Additional CSS class name for the component.
 * @param {string} props.isVisibleTermsCondition - The function to handle the visibility of the terms and conditions.
 * @param {string} props.isVisiblePrivacyPolicy - The function to handle the visibility of the privacy policy.
 * @returns {JSX.Element} The rendered Footer component.
 */
function Footer(props) {
    // #region CONTEXT
    const { aiChatSidePanelOpen } = useContext(AppContext);
    // #endregion

    // #region METHODS
    const isVisibleTermsCondition = e => {
        e.preventDefault();
    };

    const isVisiblePrivacyPolicy = e => {
        e.preventDefault();
    };
    // #endregion

    return (
        <StyledPage className={`${props?.className || ""} ${aiChatSidePanelOpen ? "isSidePanelOpen" : ""}`}>
            <div className="footer-container flex-row">
                <div className="footer-logo">
                    <img alt="logo" src={FooterLogo} />
                </div>
                <div className="left-footer-menu align-items-center">
                    <div className="control-component flex-1 compact-menu">
                        <span className="control-description">Compact Menu</span>
                        <label className="switch">
                            <SwitchButton isDisabled={true} isEnabled={false} />
                        </label>
                    </div>

                    <div className="control-component flex-1 dark-mode">
                        <span className="control-description">Dark Mode</span>
                        <label className="switch">
                            <SwitchButton isDisabled={true} isEnabled={false} />
                        </label>
                    </div>

                    <div className="control-component flex-1 tooltips">
                        <span className="control-description">Tooltips</span>
                        <label className="switch">
                            <SwitchButton isDisabled={true} isEnabled={true} />
                        </label>
                    </div>
                </div>

                <div className="right-footer-menu flex-1 align-items-center justify-content-end pr-15px">
                    <div className="footer-links">
                        <div className="link">
                            <Link to="#" className="text-default text-hover-default " onClick={isVisibleTermsCondition}>
                                <span
                                    onClick={() => {
                                        props?.setShowTAC({
                                            TermsAndPrivacyPanel: true,
                                            PrivacyPolicy: false
                                        });
                                    }}>
                                    Terms & Conditions
                                </span>
                            </Link>
                        </div>
                        <div className="link">
                            <Link to="#" className="text-default text-hover-default " onClick={isVisiblePrivacyPolicy}>
                                <span
                                    onClick={() => {
                                        props?.setShowTAC({
                                            TermsAndPrivacyPanel: false,
                                            PrivacyPolicy: true
                                        });
                                    }}>
                                    Privacy & Security
                                </span>
                            </Link>
                        </div>
                        <div className="text-inactive">
                            <span>BOtag Norge AS © {moment().format("yyyy")}</span>
                        </div>
                        <div className="text-inactive">
                            <span>{`App version ${packageJson.version}`}</span>
                        </div>
                    </div>
                </div>
            </div>
        </StyledPage>
    );
}

export default Footer;
